(() => {
  const SCRIPT_ID = "cs-auto-faq-schema";
  const MAX_ITEMS = 20;
  const SELECTOR_GROUPS = [
    {
      item: ".cs-microbio__faq-item",
      question: ".cs-microbio__faq-question",
      answer: ".cs-microbio__faq-answer"
    },
    {
      item: ".cs-organic__faq-item",
      question: ".cs-organic__faq-question",
      answer: ".cs-organic__faq-answer"
    },
    {
      item: ".csc-faq__item",
      question: ".csc-faq__question",
      answer: ".csc-faq__answer"
    },
    {
      item: ".cs-seo-faq__item",
      question: ".cs-seo-faq__question",
      answer: ".cs-seo-faq__answer"
    },
    {
      item: ".state-faq__item",
      question: "summary",
      answer: ".state-faq__answer"
    },
    {
      item: ".simesy-product-faq .simesyfaq, .simesy-faq-widget .simesyfaq",
      question: ".simesyfaq__text, .simesyfaq__question",
      answer: ".simesyfaq__answercontent, .simesyfaq__answer"
    }
  ];

  const cleanText = (value) => {
    if (!value) return "";
    const text = typeof value === "string" ? value : value.textContent || "";
    return text.replace(/\s+/g, " ").trim();
  };

  const normalizeKey = (question, answer) => {
    return `${cleanText(question).toLowerCase()}::${cleanText(answer).toLowerCase()}`;
  };

  const faqScripts = () => {
    return Array.from(document.querySelectorAll('script[type="application/ld+json"]')).filter((script) => {
      return /"@type"\s*:\s*"FAQPage"/.test(script.textContent || "");
    });
  };

  const addItem = (items, seen, question, answer) => {
    question = cleanText(question);
    answer = cleanText(answer);
    const key = normalizeKey(question, answer);

    if (!question || !answer || seen.has(key)) return;
    if (question.length < 6 || answer.length < 12) return;

    seen.add(key);
    items.push({
      "@type": "Question",
      "name": question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": answer
      }
    });
  };

  const collectExistingSchemaItems = (items, seen) => {
    faqScripts().forEach((script) => {
      try {
        const schema = JSON.parse(script.textContent || "{}");
        const entries = Array.isArray(schema.mainEntity) ? schema.mainEntity : [];
        entries.forEach((entry) => {
          addItem(items, seen, entry.name, entry.acceptedAnswer && entry.acceptedAnswer.text);
        });
      } catch (_error) {
        // Ignore invalid third-party schema and let the visible FAQ fallback handle the page.
      }
    });
  };

  const collectVisibleFaqItems = (items, seen) => {
    SELECTOR_GROUPS.forEach((group) => {
      document.querySelectorAll(group.item).forEach((item) => {
        addItem(items, seen, item.querySelector(group.question), item.querySelector(group.answer));
      });
    });
  };

  const collectItems = () => {
    const seen = new Set();
    const items = [];
    collectExistingSchemaItems(items, seen);
    collectVisibleFaqItems(items, seen);
    return items.slice(0, MAX_ITEMS);
  };

  const writeSchema = () => {
    const items = collectItems();
    const existing = document.getElementById(SCRIPT_ID);

    faqScripts().forEach((script) => {
      if (script.id !== SCRIPT_ID) script.remove();
    });

    if (items.length === 0) {
      if (existing) existing.remove();
      return;
    }

    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": items
    };

    const script = existing || document.createElement("script");
    script.id = SCRIPT_ID;
    script.type = "application/ld+json";
    script.setAttribute("data-cs-faq-schema", "deduped");
    script.textContent = JSON.stringify(schema);

    if (!existing) document.head.appendChild(script);
  };

  const scheduleWrite = (() => {
    let timer = null;
    return () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(writeSchema, 250);
    };
  })();

  document.addEventListener("DOMContentLoaded", () => {
    writeSchema();
    window.setTimeout(writeSchema, 1200);
    window.setTimeout(writeSchema, 3500);
    window.setTimeout(writeSchema, 7000);

    if (document.body) {
      new MutationObserver(scheduleWrite).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  });
})();
